import { Link } from "react-router";

import type { SiteControllerType } from "@/lib/gql/__generated__/graphql";

import { getScPlanSyncManualUrl } from "./sc-plan-sync-manual-url";

type Props = {
	siteControllerType: SiteControllerType;
};

export const ScConnectedNotice = ({ siteControllerType }: Props) => {
	const manualUrl = getScPlanSyncManualUrl(siteControllerType);

	return (
		<p className="border-red-200 bg-red-50 text-red-700 rounded-md border p-4 text-sm">
			サイトコントローラーと連携中です。予約時の料金計算にはサイトコントローラーから連携された料金が優先されます。
			<br />
			{manualUrl ? (
				<Link
					to={manualUrl}
					className="text-link-400 underline-offset-4 hover:underline"
					target="_blank"
					viewTransition
				>
					詳細はこちら
				</Link>
			) : (
				"詳細はこちら"
			)}
		</p>
	);
};

ScConnectedNotice.displayName = "ScConnectedNotice";
